export const SET_AUTHENTICATED = "SET_AUTHENTICATED";
export const SET_RECIPES = "SET_RECIPES";
export const DELETE_RECIPE = "DELETE_RECIPE";
export const SELECT_RECIPE = "SELECT_RECIPE";
export const UNSELECT_RECIPE = "UNSELECT_RECIPE";
export const SET_RECIPE_QUANTITY = "SET_RECIPE_QUANTITY";
export const TOGGLE_NEED_INGREDIENT = "TOGGLE_NEED_INGREDIENT";
export const ADD_EXTRA_INGREDIENT = "ADD_EXTRA_INGREDIENT";
export const REMOVE_EXTRA_INGREDIENT = "REMOVE_EXTRA_INGREDIENT";
export const ADD_LIST = "ADD_LIST";
export const REMOVE_LIST = "REMOVE_LIST";
export const SET_LIST_CHECKED = "SET_LIST_CHECKED";
export const SET_LISTS = "SET_LISTS";
export const UPDATE_RECIPE = "UPDATE_RECIPE";
export const EDIT_LIST = "EDIT_LIST";
export const CLEAR_SHOPPING = "CLEAR_SHOPPING";
